import React from 'react';
import { Button } from './ui/button';
import { MessageSquare, ClipboardCheck, FileText, Users, ArrowRight } from 'lucide-react';

const steps = [
  {
    icon: MessageSquare,
    title: 'Beszélgetünk',
    description: 'Ingyenes, 20 perces konzultáció, ahol átbeszéljük, hol tartasz, mi a célod és mennyi időd van. Személyesen a BB Gymben vagy online – ahogy neked kényelmes.',
  },
  {
    icon: ClipboardCheck,
    title: 'Felmérünk',
    description: 'Megnézzük a tartásodat, a mozgásodat és a kiindulási állapotodat, hogy pontosan tudjuk, honnan indulunk.',
  },
  {
    icon: FileText,
    title: 'Megkapod a saját tervedet',
    description: 'Edzés és étrend, ami a te napirendedhez igazodik, nem egy letöltött sablon.',
  },
  {
    icon: Users,
    title: 'Együtt haladunk',
    description: 'Közös edzések, heti visszajelzés, kérdés esetén 24 órán belül válaszolok.',
  },
];

const HowWeWorkSection = ({ onBookClick }) => {
  return (
    <section id="how-we-work" data-testid="how-we-work-section" className="py-20 md:py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mb-12">
          <div className="inline-block mb-4 px-4 py-2 bg-yellow-100 rounded-full">
            <span className="text-yellow-700 font-semibold text-sm tracking-wider">ÍGY DOLGOZOM</span>
          </div>
          <h2
            className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Így dolgozunk együtt
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={step.title}
                data-testid={`how-we-work-step-${index}`}
                className="relative bg-white border-2 border-gray-100 rounded-xl p-6 hover:border-yellow-600 hover:shadow-xl transition-all duration-300 group"
              >
                <div className="flex items-center gap-3 mb-4">
                  <span className="inline-flex items-center justify-center w-11 h-11 rounded-lg bg-yellow-100 text-yellow-700 group-hover:bg-yellow-600 group-hover:text-white transition-colors duration-300 shrink-0">
                    <Icon size={22} />
                  </span>
                  <span
                    className="text-4xl font-bold text-gray-100 group-hover:text-yellow-100 transition-colors duration-300 leading-none"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {index + 1}
                  </span>
                </div>
                <h3
                  className="text-base md:text-lg font-bold text-gray-900 mb-2 leading-snug break-words"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed break-words">{step.description}</p>
              </div>
            );
          })}
        </div>

        <div className="flex flex-col sm:flex-row gap-3 max-w-2xl">
          <Button
            data-testid="how-we-work-book-btn"
            onClick={onBookClick}
            size="lg"
            className="flex-1 bg-yellow-600 hover:bg-yellow-500 text-gray-900 font-bold py-5 h-auto whitespace-normal leading-snug"
          >
            Ingyenes konzultációt kérek
            <ArrowRight className="ml-2 shrink-0" size={18} />
          </Button>
          <Button
            data-testid="how-we-work-programs-btn"
            variant="outline"
            size="lg"
            onClick={() => document.getElementById('programs')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
            className="flex-1 border-2 border-gray-300 text-gray-800 hover:bg-gray-900 hover:text-white hover:border-gray-900 font-bold py-5 h-auto whitespace-normal leading-snug"
          >
            Megnézem az árakat és programokat
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HowWeWorkSection;
